<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div v-if="bool_isAMV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindowSA">
                        <CCard>
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["PM"][obj_PromotionCMS.I > 0? "EPP": "APP"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="closeAdd">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content" id="PromoS">
                                    <CRow>
                                        <CCol col="12">
                                            <h6 class="card-title section-title2" @click="showSectionBasedRole('ppi')"><span>1</span>{{this.getLanguage["PM"]["PPI"]}} <i :class="setCollapseExpandIcon('PPI')"></i> </h6>
                                        </CCol>
                                    </CRow>
                                    <template v-if="bool_showPPI">
                                        <CRow class="mx-3">
                                            <CCol col="7">
                                                <label class="col-form-label-sm font-weight-bold">{{this.getLanguage["PM"]["AGI"]}}<span class="required" /> </label>
                                                <small class="d-block">{{this.getLanguage["PM"]["AGID"]}} </small>
                                            </CCol>
                                            <CCol col="5">
                                                <customtreeselect :multiple="false"
                                                                  :options="dd_agentgroup"
                                                                  :defaultExpandLevel="Infinity"
                                                                  :clearable="false"
                                                                  :flat="true"
                                                                  :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                                                  v-model="obj_PromotionCMS.AGIT"
                                                                  @input="AgentGroupChange"
                                                                  :max-height="200"
                                                                  :disabled="obj_PromotionCMS.I > 0"
                                                                  ref="AGIT" />
                                                <span class="ErrMsg">{{ ValidationPromotionCMSErrMsg('AGIT','AGI') }}</span>
                                            </CCol>
                                        </CRow>
                                        <CRow class="mx-3">
                                            <CCol col="7">
                                                <label class="col-form-label-sm font-weight-bold">{{this.getLanguage["PM"]["DLANG"]}}<span class="required" /></label>
                                                <small class="d-block">{{getLanguage["PM"]["DLANGD"]}}</small>
                                            </CCol>
                                            <CCol col="5">
                                                <treeselect :multiple="true"
                                                            :options="dd_language"
                                                            valueConsistsOf="LEAF_PRIORITY"
                                                            :noOptionsText="this.getLanguage['GL']['NOA']"
                                                            :defaultExpandLevel="1"
                                                            :placeholder="this.utilGetDDLanguage('PM.DLANG')"
                                                            v-model="obj_PromotionCMS.Language"
                                                            :limit="2"
                                                            :limitText="count => `+${count}`"
                                                            ref="Language">
                                                    <div slot="value-label" slot-scope="{ node }">
                                                        <span v-for="(data,index) in dd_language" v-if="node.id==data.id" class="flagClass" :class="mapLanguageFlag(data.id)"></span>
                                                        <span>{{ node.label }}</span>
                                                    </div>
                                                    <div slot="option-label" slot-scope="{ node, shouldShowCount, count, labelClassName }" :class="labelClassName">
                                                        <span v-for="(data,index) in dd_language" v-if="node.id==data.id" class="flagClass" :class="mapLanguageFlag(data.id)"></span>
                                                        <span>{{ node.label }}</span>
                                                    </div>
                                                </treeselect>
                                                <span class="ErrMsg">{{ ValidationPromotionCMSErrMsg('Language', 'DLANG') }}</span>
                                            </CCol>
                                        </CRow>
                                        <CRow class="mx-3">
                                            <CCol col="7">
                                                <label class="col-form-label-sm font-weight-bold">
                                                    {{this.getLanguage["PM"]["DPT"]}}<span class="required" />
                                                    <span class="custom_tooltip">
                                                        <i class="fa fa-question-circle"></i>
                                                        <span class="tooltiptext2 campaign-name">
                                                            <img src="../../../assets/images/promopreview3.png" width="500" />
                                                        </span>
                                                    </span>
                                                </label>
                                                <small class="d-block">{{this.getLanguage["PM"]["DPTD"]}} </small>
                                            </CCol>
                                            <CCol col="5">
                                                <CInput :placeholder="getLanguage['PM']['DPT']" size="sm" :value="obj_PromotionCMS.PT"
                                                        @change="v => obj_PromotionCMS.PT = v" maxlength="200" ref="PT"></CInput>
                                                <span class="WCMsg mt-0" v-if="this.obj_PromotionCMS.PT != null">{{ this.obj_PromotionCMS.PT.length }} / 200 </span>
                                                <span class="WCMsg mt-0" v-else> 0 / 200 </span>
                                                <span class="ErrMsg">{{ ValidationPromotionCMSErrMsg('PT', 'DPT') }}</span>

                                                <div class="form-check form-check-inline">
                                                    <input type="checkbox" id="enableCustomURL" class="inline" v-model="bool_unlockCusUrl" :checked="bool_unlockCusUrl" @change="v => bool_unlockCusUrl = v.target.checked" />
                                                    <label for="enableCustomURL" class="col-form-label-sm ml-2">{{this.getLanguage["PM"]["ECU"]}}</label>
                                                </div>
                                                <template v-if="bool_unlockCusUrl">
                                                    <CInput :placeholder="getLanguage['PM']['PURL']" size="sm" :value="obj_PromotionCMS.PURL" :disabled="!bool_unlockCusUrl"
                                                            @change="v => obj_PromotionCMS.PURL = v" maxlength="200" ref="PURL"></CInput>
                                                    <span class="WCMsg mt-0" v-if="this.obj_PromotionCMS.PURL != null">{{ this.obj_PromotionCMS.PURL.length }} / 200 </span>
                                                    <span class="WCMsg mt-0" v-else> 0 / 200 </span>
                                                    <span class="ErrMsg">{{ ValidationPromotionCMSErrMsg('PURL', 'E1002') }}</span>
                                                </template>
                                            </CCol>
                                        </CRow>
                                        <CRow class="mx-3">
                                            <CCol col="7">
                                                <label class="col-form-label-sm font-weight-bold">
                                                    {{this.getLanguage["MEM"]["PROMO"]}} {{this.getLanguage["PM"]["DDESC"]}}<span class="required" />
                                                    <span class="custom_tooltip">
                                                        <i class="fa fa-question-circle"></i>
                                                        <span class="tooltiptext2 campaign-name">
                                                            <img src="../../../assets/images/promopreview4.png" width="500" />
                                                        </span>
                                                    </span>
                                                </label>
                                                <small class="d-block">{{this.getLanguage["PM"]["DSDESCD"]}} </small>
                                            </CCol>
                                            <CCol col="5">
                                                <CInput :placeholder="getLanguage['PM']['DSDESC']" size="sm" :value="obj_PromotionCMS.PSD"
                                                        @change="v => obj_PromotionCMS.PSD = v" maxlength="1000" ref="PSD"></CInput>
                                                <span class="WCMsg mt-0" v-if="this.obj_PromotionCMS.PSD != null">{{ this.obj_PromotionCMS.PSD.length }} / 1000 </span>
                                                <span class="WCMsg mt-0" v-else> 0 / 1000 </span>
                                                <span class="ErrMsg">{{ ValidationPromotionCMSErrMsg('PSD', 'DSDESC') }}</span>
                                            </CCol>
                                        </CRow>


                                        <CRow class="mx-3">
                                            <CCol col="7">
                                                <label class="col-form-label-sm font-weight-bold">{{this.getLanguage["PM"]["PMDU2"]}} </label>
                                                <small class="d-block">{{this.getLanguage["PM"]["PCD1"]}} </small>
                                            </CCol>
                                            <CCol col="5">
                                                <treeselect :multiple="false"
                                                            :options="dd_promocode"
                                                            :placeholder="this.utilGetDDLanguage('PM.PM')"
                                                            :noOptionsText="this.getLanguage['GL']['NOA']"
                                                            :max-height="200"
                                                            v-model="obj_PromotionCMS.PI"
                                                            ref="PI" />
                                                <span class="ErrMsg">{{ ValidationPromotionCMSErrMsg('PI', 'PM') }}</span>
                                            </CCol>
                                        </CRow>

                                        <CRow class="mx-3">
                                            <CCol col="7">
                                                <label class="col-form-label-sm font-weight-bold">{{this.getLanguage["PM"]["PPR"]}}<span class="required" /></label>
                                                <small class="d-block"> {{getLanguage["PM"]["PPRC"]}} </small>
                                            </CCol>
                                            <CCol col="5">
                                                <CInput placeholder="1 - 25" size="sm" :value="obj_PromotionCMS.PP"
                                                        @change="v => obj_PromotionCMS.PP = v"></CInput>
                                                <!--<treeselect :multiple="false"
            :options="dd_po"
            :placeholder="this.utilGetDDLanguage('BN.BP')"
            v-model="obj_PromotionCMS['PP']"
            @input="positionChange"
            ref="PP" />-->
                                                <span class="ErrMsg">{{ ValidationPromotionCMSErrMsg('PP', 'PPR') }}</span>
                                            </CCol>
                                        </CRow>
                                        <CRow class="mx-3">
                                            <CCol col="7">
                                                <label class="col-form-label-sm font-weight-bold">{{this.getLanguage["PM"]["PCI"]}}</label>
                                            </CCol>
                                            <CCol col="5">
                                                <treeselect :multiple="false"
                                                            :options="dd_promocate"
                                                            :placeholder="this.utilGetDDLanguage('PM.PM')"
                                                            :max-height="200"
                                                            v-model="obj_PromotionCMS.PCI" />
                                            </CCol>
                                        </CRow>



                                        <!--image-->

                                        <CRow class="mx-3">
                                            <CCol col="7">
                                                <label class="col-form-label-sm font-weight-bold">
                                                    {{getLanguage["PM"]["PLI"]}} <span class="text-danger">({{getLanguage["RIZ"]["IZ"]}} 500 X 500)</span><span class="required" />
                                                    <span class="custom_tooltip">
                                                        <i class="fa fa-question-circle"></i>
                                                        <span class="tooltiptext2 campaign-name">
                                                            <img src="../../../assets/images/promopreview1.png" width="500" />
                                                        </span>
                                                    </span>
                                                </label>
                                                <img :class="portraitOrientation" :src="portraitPreview" />
                                            </CCol>
                                            <CCol col="5">
                                                <div class="PopUpActions">
                                                    <input class="PopUpActions-fileInput" id="validatedCustomFile2" type="file" name="pic" accept="image/*" @change="onPMIUFileSelected" required>
                                                    <label for="validatedCustomFile2" class="PopUpActions-filePicker" v-if="NewPMIUFile === null">
                                                        <i class="fa-solid fa-image mr-3"></i> Choose Photo
                                                    </label>
                                                    <label for="validatedCustomFile2" class="PopUpActions-filePicker" v-else>
                                                        {{NewPMIUFile.name}}
                                                    </label>
                                                    <div class="invalid-feedback">{{ getLanguage['ERR']['8007'] }}</div>
                                                    <div class="PopUpActions-divider">
                                                        <span class="PopUpActions-divider--line"></span>or
                                                        <span class="PopUpActions-divider--line"></span>
                                                    </div>
                                                    <div class="PopUpActions-textPicker">
                                                        <input type="url" class="form-control" :placeholder="getLanguage['CTAB']['U']" v-model="obj_PromotionCMS.PMIU" @change="NewPMIUFile = null;portraitOrientation=null;portraitPreview= obj_PromotionCMS['PMIU'];checkImageOrientation2();">
                                                    </div>
                                                </div>
                                                <span class="ErrMsg">{{ ValidationPromotionCMSErrMsg('PMIU', 'DPMIMG') }}</span>
                                            </CCol>
                                        </CRow>
                                        <CRow class="mx-3">
                                            <CCol col="7">
                                                <label class="col-form-label-sm font-weight-bold">
                                                    {{getLanguage["PM"]["PLI"]}}  {{getLanguage["SEO"]["AT"]}}
                                                </label>
                                            </CCol>
                                            <CCol col="5">
                                                <CInput maxlength="100" size="sm" v-model="obj_PromotionCMS.ATP" />
                                                <span class="WCMsg mt-0" v-if="this.obj_PromotionCMS.ATP != null">{{ this.obj_PromotionCMS.ATP.length }} / 125 </span>
                                                <span class="WCMsg mt-0" v-else> 0 / 125 </span>
                                            </CCol>
                                        </CRow>

                                        <CRow class="mx-3">
                                            <CCol col="7">
                                                <label class="col-form-label-sm  font-weight-bold">
                                                    {{getLanguage["PM"]["PDI"]}} <span class="text-danger">({{getLanguage["RIZ"]["IZ"]}} 1920 X 500)</span><span class="required" />
                                                    <span class="custom_tooltip">
                                                        <i class="fa fa-question-circle"></i>
                                                        <span class="tooltiptext2 campaign-name">
                                                            <img src="../../../assets/images/promopreview2.png" width="500" />
                                                        </span>
                                                    </span>
                                                </label>
                                                <img :class="landscapeOrientation" :src="landscapePreview" />
                                            </CCol>
                                            <CCol col="5">
                                                <div class="PopUpActions">
                                                    <input class="PopUpActions-fileInput" id="validatedCustomFile" type="file" name="pic" accept="image/*" @change="onPIUFileSelected" required>
                                                    <label for="validatedCustomFile" class="PopUpActions-filePicker" v-if="NewPIUFile === null">
                                                        <i class="fa-solid fa-image mr-3"></i> Choose Photo
                                                    </label>
                                                    <label for="validatedCustomFile" class="PopUpActions-filePicker" v-else>
                                                        {{NewPIUFile.name}}
                                                    </label>
                                                    <div class="invalid-feedback">{{ getLanguage['ERR']['8007'] }}</div>
                                                    <div class="PopUpActions-divider">
                                                        <span class="PopUpActions-divider--line"></span>or
                                                        <span class="PopUpActions-divider--line"></span>
                                                    </div>
                                                    <div class="PopUpActions-textPicker">
                                                        <input type="url" class="form-control" :placeholder="getLanguage['CTAB']['U']" v-model="obj_PromotionCMS.PIU" @change="NewPIUFile = null;landscapeOrientation=null;landscapePreview= obj_PromotionCMS['PIU'];checkImageOrientation();">
                                                    </div>
                                                </div>
                                                <span class="ErrMsg">{{ ValidationPromotionCMSErrMsg('PIU', 'DPIMG') }}</span>
                                            </CCol>
                                        </CRow>
                                        <CRow class="mx-3">
                                            <CCol col="7">
                                                <label class="col-form-label-sm font-weight-bold">
                                                    {{getLanguage["PM"]["PDI"]}}  {{getLanguage["SEO"]["AT"]}}
                                                </label>
                                            </CCol>
                                            <CCol col="5">
                                                <CInput maxlength="100" size="sm" v-model="obj_PromotionCMS.ATL" />
                                                <span class="WCMsg mt-0" v-if="this.obj_PromotionCMS.ATL != null">{{ this.obj_PromotionCMS.ATL.length }} / 125 </span>
                                                <span class="WCMsg mt-0" v-else> 0 / 125 </span>
                                            </CCol>
                                        </CRow>

                                        <CRow class="mx-3">
                                            <CCol col="12">
                                                <label class="col-form-label-sm font-weight-bold">{{this.getLanguage["PM"]["PDTNC"]}}<span class="required" /></label>
                                                <editor id="htmluuid" @onChange="HTMLEditorTextChange" :value="obj_PromotionCMS.PFD" :init="init" />
                                                <span class="ErrMsg">{{ ValidationPromotionCMSErrMsg('PFD', 'DFDESC') }}</span>
                                            </CCol>
                                        </CRow>
                                    </template>
                                    <CRow>
                                        <CCol col="12">
                                            <h6 class="card-title section-title2" @click="showSectionBasedRole('as')"><span>2</span>{{this.getLanguage["PM"]["AS"]}} <i :class="setCollapseExpandIcon('AS')"></i> </h6>
                                        </CCol>
                                    </CRow>
                                    <template v-if="bool_showAS">
                                        <CRow class="mx-3" v-if="bool_enableMultiPage">
                                            <CCol col="7">
                                                <label class="col-form-label-sm font-weight-bold">{{this.getLanguage["PM"]["DPOMRF"]}} </label>
                                            </CCol>
                                            <CCol col="5">
                                                <label class="switch">
                                                    <input type="checkbox" true-value="2" false-value="1" v-model="obj_PromotionCMS.ARP">
                                                    <span class="slider round"></span>
                                                </label>
                                            </CCol>
                                        </CRow>


                                        <CRow class="mx-3">
                                            <CCol col="7">
                                                <label class="col-form-label-sm font-weight-bold">{{this.getLanguage["SEO"]["OT"]}}</label>
                                            </CCol>
                                            <CCol col="5">
                                                <CInput maxlength="100" size="sm" :value="obj_PromotionCMS.OT" @change="v => obj_PromotionCMS.OT = v" />
                                                <span class="WCMsg mt-0" v-if="this.obj_PromotionCMS.OT != null">{{ this.obj_PromotionCMS.OT.length }} / 100 </span>
                                                <span class="WCMsg mt-0" v-else> 0 / 100 </span>
                                            </CCol>
                                        </CRow>
                                        <CRow class="mx-3">
                                            <CCol col="7">
                                                <label class="col-form-label-sm font-weight-bold">{{this.getLanguage["SEO"]["OTP"]}}</label>
                                            </CCol>
                                            <CCol col="5">
                                                <CInput maxlength="100" size="sm" :value="obj_PromotionCMS.OTP" @change="v => obj_PromotionCMS.OTP = v" />
                                                <span class="WCMsg mt-0" v-if="this.obj_PromotionCMS.OTP != null">{{ this.obj_PromotionCMS.OTP.length }} / 100 </span>
                                                <span class="WCMsg mt-0" v-else> 0 / 100 </span>
                                            </CCol>
                                        </CRow>
                                        <CRow class="mx-3">
                                            <CCol col="7">
                                                <label class="col-form-label-sm font-weight-bold">{{this.getLanguage["SEO"]["OD"]}}</label>
                                            </CCol>
                                            <CCol col="5">
                                                <textarea maxlength="1000" vertical="" rows="6" class="form-control form-control-sm" v-model="obj_PromotionCMS.OD"></textarea>
                                                <span class="WCMsg mt-0" v-if="this.obj_PromotionCMS.OD != null">{{ this.obj_PromotionCMS.OD.length }} / 1000 </span>
                                                <span class="WCMsg mt-0" v-else> 0 / 1000 </span>
                                            </CCol>
                                        </CRow>
                                        <CRow class="mx-3">
                                            <CCol col="7">
                                                <label class="col-form-label-sm font-weight-bold">
                                                    {{getLanguage["SEO"]["OI"]}}
                                                </label>
                                                <img :class="ogOrientation" :src="ogPreview" />
                                            </CCol>
                                            <CCol col="5">
                                                <div class="PopUpActions">
                                                    <input class="PopUpActions-fileInput" id="validatedCustomFile3" type="file" name="pic" accept="image/*" @change="onOIIUFileSelected" required>
                                                    <label for="validatedCustomFile3" class="PopUpActions-filePicker" v-if="NewOIIUFile === null">
                                                        <i class="fa-solid fa-image mr-3"></i> Choose Photo
                                                    </label>
                                                    <label for="validatedCustomFile3" class="PopUpActions-filePicker" v-else>
                                                        {{NewOIIUFile.name}}
                                                    </label>
                                                    <div class="invalid-feedback">{{ getLanguage['ERR']['8007'] }}</div>
                                                    <div class="PopUpActions-divider">
                                                        <span class="PopUpActions-divider--line"></span>or
                                                        <span class="PopUpActions-divider--line"></span>
                                                    </div>
                                                    <div class="PopUpActions-textPicker">
                                                        <input type="url" class="form-control" :placeholder="getLanguage['CTAB']['U']" v-model="obj_PromotionCMS.OI" @change="NewOIIUFile = null;ogOrientation=null;ogPreview= obj_PromotionCMS['OI'];checkImageOrientation3();">
                                                    </div>
                                                </div>
                                                <!--<span class="ErrMsg">{{ ValidationPromotionCMSErrMsg('OI', 'DPMIMG') }}</span>-->
                                            </CCol>
                                        </CRow>
                                        <CRow class="mx-3">
                                            <CCol col="7">
                                                <label class="col-form-label-sm font-weight-bold">{{this.getLanguage["SEO"]["HS"]}}</label>
                                                <small class="d-block">{{this.getLanguage["SEO"]["HSD"]}} </small>
                                            </CCol>
                                            <CCol col="5">
                                                <span class="ErrMsg">{{this.getLanguage["SEO"]["WRN"]}}</span>
                                                <textarea vertical="" rows="6" class="form-control form-control-sm" :value="obj_PromotionCMS.HS" @change="TextValueChange('HS',$event)" v-shortkey.avoid />
                                            </CCol>
                                        </CRow>
                                        <CRow class="mx-3">
                                            <CCol col="7">
                                                <label class="col-form-label-sm font-weight-bold">{{this.getLanguage["SEO"]["FS"]}}</label>
                                                <small class="d-block">{{this.getLanguage["SEO"]["FSD"]}} </small>
                                            </CCol>
                                            <CCol col="5">
                                                <span class="ErrMsg">{{this.getLanguage["SEO"]["WRN"]}}</span>
                                                <textarea vertical="" rows="6" class="form-control form-control-sm" :value="obj_PromotionCMS.FS" @change="TextValueChange('FS',$event)" v-shortkey.avoid />
                                            </CCol>
                                        </CRow>
                                    </template>
                                </div>
                                <div style="text-align:center;margin-top:20px">
                                    <CButton color="outline-success" size="sm" @click="savePromotionCMS()">
                                        <span class='fa fa-save mr-2'></span>
                                        {{ getLanguage["BTN"]["SV"] }}
                                    </CButton>
                                </div>
                                <label class="mandatory_Field">{{this.getLanguage['MANDATORY']['FIELDS']}}</label>

                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="bool_fullPreview">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow">
                        <CCard>
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="8">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["GL"]["P"]}}</h4>
                                    </CCol>
                                    <CCol col="4">
                                        <CButton id="btn-close1" class="float-right" @click="closeAdd1">
                                            <CIcon name="cilX"></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content text-center">
                                    <img :src="previewUrl" class="img-fluid" v-if="previewUrl">
                                    <p v-else>{{this.getLanguage['GL']['NR']}}</p>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="bool_isDDMV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow" style="max-width: 450px;">
                        <CCard>
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["R"]["CSL"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="bool_isDDMV = false">
                                            <CIcon name="cilX"></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <div class="text-right">
                                        <CButton class="mb-1 btnReset" @click="resetColumn()" v-if="needResetHeaders">
                                            <span class="font-weight-bold cil-reload"></span>
                                            {{this.getLanguage["DM"]["RST"]}}  {{this.getLanguage["BTN"]["COL"]}}
                                        </CButton>
                                    </div>

                                    <draggable v-model="reportHeaders" tag="ul" class="p-0 mb-0 sorttable">
                                        <li v-for="header in reportHeaders" :key="header" scope="col" class="list-group-item p-2">
                                            <template v-if="header == 'NO'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{ getLanguage["GL"]["NO"] }}
                                            </template>
                                            <template v-else-if="header == 'ACT' && (checkModuleAccess2(constAccessType.edit) || checkModuleAccess2(constAccessType.delete))">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["GL"]["ACT"]}}
                                            </template>
                                            <template v-else-if="header == 'RS'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{ getLanguage["PM"]["ST"] }}
                                            </template>
                                            <template v-else-if="header == 'BN'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{ getLanguage["PM"]["AGI"] }}
                                                <i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'P'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{ getLanguage["PM"]["PUB"] }}
                                                <i @click="setSortTable('RS')" :class="setSortLogo('RS')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'C'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{ getLanguage["PM"]["CB"] }}
                                            </template>
                                            <template v-else-if="header == 'O'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{ getLanguage["SUB"]["OLT"] }}
                                            </template>
                                            <template v-else-if="header == 'PN'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{ getLanguage["PM"]["PC"] }}
                                                <i @click="setSortTable('PC')" :class="setSortLogo('PC')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'L'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{ getLanguage["PM"]["DLANG"] }}
                                                <i @click="setSortTable('L')" :class="setSortLogo('L')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'PT'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{ getLanguage["PM"]["DPT"] }}
                                                <i @click="setSortTable('PT')" :class="setSortLogo('PT')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'PTY'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{ getLanguage["PM"]["PG"] }} / {{ getLanguage["PM"]["DSDESC"] }}
                                                <i @click="setSortTable('PSD')" :class="setSortLogo('PSD')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'CTS'">
                                                <i class="fa fa-times" @click="removeColumn(header)" style="margin-top: 9px;"></i>
                                                <div class="d-inline-block"><span class="grid-line">{{ getLanguage["GL"]["CT"] }} /</span><span class="grid-line">{{ getLanguage["GL"]["UTS"] }}</span></div>
                                                <i @click="setSortTable('PG')" :class="setSortLogo('PG')" class="sortlogo" style="margin-top: 9px;"></i>
                                            </template>
                                            <template v-else-if="header == 'LI'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{ getLanguage["PM"]["DPIMG"] }}
                                            </template>
                                            <template v-else-if="header == 'PI'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{ getLanguage["PM"]["DPMIMG"] }}
                                            </template>
                                        </li>
                                    </draggable>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader position-relative'>
                        <h2 id="titleHeight">{{this.getLanguage["PM"]["PP"]}}</h2>
                        <CButton size="sm" color="outline-info" v-if="checkModuleAccess2(constAccessType.add)" @click="addPromotionCMS()"><span class='plusIcon cil-plus'></span>{{this.getLanguage["BTN"]["AN"]}}</CButton>

                        <div class="custom_tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="tooltiptext tooltip-left" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="tooltiptext tooltip-left" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class='searchBox'>
                            <div v-if="!isSubAgent" class='searchCol'>
                                <span class='searchLabel80'>{{this.getLanguage["PM"]["AGI"]}} :</span>
                                <customtreeselect :multiple="false"
                                                  :options="dd_agentgroupfs"
                                                  :defaultExpandLevel="Infinity"
                                                  :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                                  v-model="arr_FV['AGI']" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel80'>{{this.getLanguage["GL"]["S"]}} :</span>
                                <treeselect :multiple="false"
                                            :options="dd_promoStatus"
                                            :placeholder="this.utilGetDDLanguage('GL.S')"
                                            v-model="arr_FV['ST']" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["GL"]["SD"]}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="center"
                                                   :auto-apply="true"
                                                   v-model="arr_FV['CTS']"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="arr_FV['CTS'].startDate != ''">
                                            <CInput size="sm"
                                                    :value="arr_FV['CTS'].startDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["GL"]["ED"]}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="left"
                                                   :auto-apply="true"
                                                   v-model="arr_FV['CTS']"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="arr_FV['CTS'].endDate != ''">
                                            <CInput size="sm"
                                                    :value="arr_FV['CTS'].endDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["PM"]["DPT"]}} / {{this.getLanguage["PM"]["DDESC"]}} :</span>
                                <CInput size="sm" :value="arr_FV.PT" @change="v => arr_FV.PT = v"></CInput>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["PM"]["PC"]}} :</span>
                                <CInput size="sm" :value="arr_FV.PC" @change="v => arr_FV.PC = v"></CInput>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["PM"]["DLANG"]}} :</span>
                                <treeselect :multiple="true"
                                            :options="dd_languagefs"
                                            :placeholder="this.utilGetDDLanguage('PM.DLANG')"
                                            valueConsistsOf="LEAF_PRIORITY"
                                            :defaultExpandLevel="Infinity"
                                            v-model="arr_FV['L']"
                                            :limit="1"
                                            :limitText="count => `+${count}`">
                                    <div slot="value-label" slot-scope="{ node }">
                                        <span v-for="(data,index) in dd_languagefs[0].children" v-if="node.id==data.id" class="flagClass" :class="mapLanguageFlag(data.id)"></span>
                                        <span>{{ node.label }}</span>
                                    </div>
                                    <div slot="option-label" slot-scope="{ node, shouldShowCount, count, labelClassName }" :class="labelClassName">
                                        <span v-for="(data,index) in dd_languagefs[0].children" v-if="node.id==data.id" class="flagClass" :class="mapLanguageFlag(data.id)"></span>
                                        <span>{{ node.label }}</span>
                                    </div>
                                </treeselect>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["PM"]["PUBL"]}} :</span>
                                <treeselect :multiple="false"
                                            :options="dd_publishingStatus"
                                            :placeholder="this.utilGetDDLanguage('PM.PUBL')"
                                            v-model="arr_FV['PUBL']" />
                            </div>
                        </div>
                        <div class='searchBtnCol'>
                            <CButton v-hotkey="keymap" ref="search" class='searchBtn' size="sm" block color="success" @click="newSearch()">
                                <span class='searchIcon cil-search'></span>
                                <span>{{this.getLanguage["BTN"]["SR"]}}</span>
                            </CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>
        </div>

        <div class="container-fluid">
            <div class='table-wrapper'>
                <header class="table-header">
                    <strong>
                        {{getLanguage['PM']['PPL']}}
                        <span class="custom_tooltip">
                            <i class="fa fa-question-circle"></i>
                            <span class="tooltiptext2 campaign-name" style="top: -125px;">
                                <span v-html='getLanguage["PM"]["PPSD"]'></span>
                            </span>
                        </span>
                    </strong>

                    <div class="pageBtn">
                        <CButton class="btnReset" @click="bool_isDDMV = true"><span class="fa-solid fa-up-down"></span>{{this.getLanguage['R']['CS']}}</CButton>
                        <CButton class="btnReset" @click="resetColumn()" v-if="needResetHeaders">
                            <span class="font-weight-bold cil-reload"></span>
                            {{this.getLanguage["DM"]["RST"]}}  {{this.getLanguage["BTN"]["COL"]}}
                        </CButton>
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </header>

                <div class="custom-table-wrapper" id="tHead">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <draggable v-model="reportHeaders" tag="tr">
                                <th v-for="header in reportHeaders" :key="header" scope="col" :class="renderClassName(header)">
                                    <template v-if="header == 'NO'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["GL"]["NO"] }}
                                    </template>
                                    <template v-else-if="header == 'ACT' && (checkModuleAccess2(constAccessType.edit) || checkModuleAccess2(constAccessType.delete))">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["GL"]["ACT"]}}
                                    </template>
                                    <template v-else-if="header == 'RS'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["PM"]["ST"] }}
                                    </template>
                                    <template v-else-if="header == 'BN'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["PM"]["AGI"] }}
                                        <i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'P'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["PM"]["PUB"] }}
                                        <i @click="setSortTable('RS')" :class="setSortLogo('RS')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'C'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["PM"]["CB"] }}
                                    </template>
                                    <template v-else-if="header == 'O'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["SUB"]["OLT"] }}
                                    </template>
                                    <template v-else-if="header == 'PN'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["PM"]["PC"] }}
                                        <i @click="setSortTable('PC')" :class="setSortLogo('PC')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'L'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["PM"]["DLANG"] }}
                                        <i @click="setSortTable('L')" :class="setSortLogo('L')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'PT'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["PM"]["DPT"] }}
                                        <i @click="setSortTable('PT')" :class="setSortLogo('PT')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'PTY'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["PM"]["PG"] }} / {{ getLanguage["PM"]["DSDESC"] }}
                                        <i @click="setSortTable('PSD')" :class="setSortLogo('PSD')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'CTS'">
                                        <i class="fa fa-times" @click="removeColumn(header)" style="margin-top: 9px;"></i>
                                        <div class="d-inline-block"><span class="grid-line">{{ getLanguage["GL"]["CT"] }} /</span><span class="grid-line">{{ getLanguage["GL"]["UTS"] }}</span></div>
                                        <i @click="setSortTable('PG')" :class="setSortLogo('PG')" class="sortlogo" style="margin-top: 9px;"></i>
                                    </template>
                                    <template v-else-if="header == 'LI'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["PM"]["DPIMG"] }}
                                    </template>
                                    <template v-else-if="header == 'PI'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["PM"]["DPMIMG"] }}
                                    </template>
                                </th>
                            </draggable>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class='custom-table afb-blue '>
                        <thead>
                            <draggable v-model="reportHeaders" tag="tr">
                                <th v-for="header in reportHeaders" :key="header" scope="col" :class="renderClassName(header)">
                                    <template v-if="header == 'NO'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["GL"]["NO"] }}
                                    </template>
                                    <template v-else-if="header == 'ACT' && (checkModuleAccess2(constAccessType.edit) || checkModuleAccess2(constAccessType.delete))">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["GL"]["ACT"]}}
                                    </template>
                                    <template v-else-if="header == 'RS'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["PM"]["ST"] }}
                                    </template>
                                    <template v-else-if="header == 'BN'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["PM"]["AGI"] }}
                                        <i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'P'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["PM"]["PUB"] }}
                                        <i @click="setSortTable('RS')" :class="setSortLogo('RS')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'C'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["PM"]["CB"] }}
                                    </template>
                                    <template v-else-if="header == 'O'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["SUB"]["OLT"] }}
                                    </template>
                                    <template v-else-if="header == 'PN'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["PM"]["PC"] }}
                                        <i @click="setSortTable('PC')" :class="setSortLogo('PC')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'L'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["PM"]["DLANG"] }}
                                        <i @click="setSortTable('L')" :class="setSortLogo('L')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'PT'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["PM"]["DPT"] }}
                                        <i @click="setSortTable('PT')" :class="setSortLogo('PT')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'PTY'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["PM"]["PG"] }} / {{ getLanguage["PM"]["DSDESC"] }}
                                        <i @click="setSortTable('PSD')" :class="setSortLogo('PSD')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'CTS'">
                                        <i class="fa fa-times" @click="removeColumn(header)" style="margin-top: 9px;"></i>
                                        <div class="d-inline-block"><span class="grid-line">{{ getLanguage["GL"]["CT"] }} /</span><span class="grid-line">{{ getLanguage["GL"]["UTS"] }}</span></div>
                                        <i @click="setSortTable('PG')" :class="setSortLogo('PG')" class="sortlogo" style="margin-top: 9px;"></i>
                                    </template>
                                    <template v-else-if="header == 'LI'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["PM"]["DPIMG"] }}
                                    </template>
                                    <template v-else-if="header == 'PI'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{ getLanguage["PM"]["DPMIMG"] }}
                                    </template>
                                </th>
                            </draggable>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if=" arr_PromotionCMS.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <tr v-for="(data,index) in arr_PromotionCMS">
                            <td v-for="header in reportHeaders" :key="header+data.I+data.PI" :class="renderClassName(header, data)">
                                <template v-if="header == 'NO'">
                                    {{ CountItem(index+1) }}
                                </template>
                                <template v-if="header == 'ACT' && (checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete))">
                                    <span id="actionBtnCol">
                                        <div class="custom_tooltip" v-if="checkModuleAccess2(constAccessType.delete) && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" style="display: block;">
                                            <i class="cil-trash" @click="removePromotionCMS(data)"></i>
                                            <span class="tooltiptext">{{getLanguage["BTN"]["DLT"]}}</span>
                                        </div>
                                        <div class="custom_tooltip" v-if="checkModuleAccess2(constAccessType.delete) && (isSENS == 1 && data.AGI != curAGI)" style="display: block;">
                                            <i class="cil-trash"></i>
                                            <span class="tooltiptext">{{getLanguage["BTN"]["DLT"]}}</span>
                                        </div>
                                        <div class="custom_tooltip" v-if="checkModuleAccess2(constAccessType.edit) && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" style="display: block;">
                                            <i class="cil-color-border" @click="editPromotionCMS(data.I)"></i>
                                            <span class="tooltiptext">{{getLanguage["BTN"]["ED"]}}</span>
                                        </div>
                                        <div class="custom_tooltip" v-if="checkModuleAccess2(constAccessType.edit) && (isSENS == 1 && data.AGI != curAGI)" style="display: block;">
                                            <i class="cil-color-border"></i>
                                            <span class="tooltiptext">{{getLanguage["BTN"]["ED"]}}</span>
                                        </div>
                                    </span>
                                </template>
                                <template v-if="header == 'RS'">
                                    <span style="width:80px;display:block">
                                        <span v-if="data.PI==0">
                                            -
                                        </span>
                                        <span :style="checkStatusColor(data.PS, data.PFTS)" v-else-if="data.status">
                                            {{checkStatus(data.PS, data.PFTS)}}
                                        </span>
                                        <span style="color:red;" v-else>
                                            {{getLanguage["AN"]["E"]}}
                                        </span>
                                    </span>
                                </template>
                                <template v-if="header == 'BN'">
                                    <span class="">{{ data.GN }} ({{ data.GPC }})</span>
                                </template>
                                <template v-if="header == 'P'">
                                    <!--<span style="color: green;" v-if="data.RS==2">{{ getLanguage["GL"]["YES"] }}</span>
                                    <span v-else style="color: red;">{{ getLanguage["CNO"]["NO"] }}</span>-->


                                    <label class="switch">
                                        <input type="checkbox" v-if="data.RS == '2'" checked @change="savePublishStatus(data)" :id="'p'+data.I+data.PI" :disabled="!checkModuleAccess2(constAccessType.edit)">
                                        <input type="checkbox" v-else @change="savePublishStatus(data)" :id="'p'+data.I+data.PI" :disabled="!checkModuleAccess2(constAccessType.edit)">
                                        <span class="slider round" :style="disabledPointer()"></span>
                                    </label>

                                </template>
                                <template v-if="header == 'C'">
                                    <!--<span style="color: green;" v-if="data.SB==1">{{ getLanguage["GL"]["YES"] }}</span>
                                    <span v-else style="color: red; text-align: center;">{{ getLanguage["CNO"]["NO"] }}</span>-->

                                    <label class="switch">
                                        <input type="checkbox" v-if="data.SB" checked @change="saveClaimStatus(data)" :id="'c'+data.I+data.PI" :disabled="!checkModuleAccess2(constAccessType.edit)">
                                        <input type="checkbox" v-else @change="saveClaimStatus(data)" :id="'c'+data.I+data.PI" :disabled="!checkModuleAccess2(constAccessType.edit)">
                                        <span class="slider round" :style="disabledPointer()"></span>
                                    </label>
                                </template>
                                <template v-if="header == 'O'">
                                    <!--<span style="color: green;" v-if="data.POL==1">{{ getLanguage["GL"]["YES"] }}</span>
                                    <span v-else style="color: red;">{{ getLanguage["CNO"]["NO"] }}</span>-->

                                    <label class="switch">
                                        <input type="checkbox" v-if="data.POL" checked @change="saveOutletAgentStatus(data)" :id="'o'+data.I+data.PI" :disabled="!checkModuleAccess2(constAccessType.edit)">
                                        <input type="checkbox" v-else @change="saveOutletAgentStatus(data)" :id="'o'+data.I+data.PI" :disabled="!checkModuleAccess2(constAccessType.edit)">
                                        <span class="slider round" :style="disabledPointer()"></span>
                                    </label>
                                </template>
                                <template v-if="header == 'PN'">
                                    <span v-if="data.PI != 0">{{ data.PC }}</span>
                                    <span v-else>-</span>
                                </template>
                                <template v-if="header == 'L'">
                                    <span class="grid-line" v-for="lang in data.Languages">{{ lang }}</span>
                                </template>
                                <template v-if="header == 'PT'">
                                    <div style="max-width: 400px; word-break: break-word; white-space: normal;display: block">
                                        {{ data.PT }}
                                    </div>
                                </template>
                                <template v-if="header == 'PTY'">
                                    <div class="multiline" style="max-width: 400px; word-break: break-word; white-space: normal; display: block">
                                        <span class="grid-line">{{ renderPromotionGroup(data.PG) }}</span>
                                        <span class="grid-line">{{ data.PSD }}</span>
                                    </div>
                                </template>
                                <template v-if="header == 'CTS'">
                                    <span class="grid-line">{{ formatDateTime(data.CTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</span>
                                    <span class="grid-line">{{ formatDateTime(data.UTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</span>
                                </template>
                                <template v-if="header == 'LI'">
                                    <div v-if="((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)">
                                        <a href="javascript:void(0)" style="color:blue" @click="setPreview(data.PIU)">
                                            <u>{{getLanguage["GL"]["P"]}}</u>
                                        </a>
                                    </div>
                                    <div v-else-if="(isSENS == 1 && data.AGI != curAGI)">
                                        <a href="javascript:void(0)" style="color:blue">
                                            <u>{{getLanguage["GL"]["P"]}}</u>
                                        </a>
                                    </div>
                                </template>
                                <template v-if="header == 'PI'">
                                    <div v-if="((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)">
                                        <a href="javascript:void(0)" style="color:blue" @click="setPreview(data.PMIU)" v-if="data.PMIU!=''">
                                            <u>{{getLanguage["GL"]["P"]}}</u>
                                        </a>
                                        <div v-else>-</div>
                                    </div>
                                    <div v-else-if="(isSENS == 1 && data.AGI != curAGI)">
                                        <a href="javascript:void(0)" style="color:blue" v-if="data.PMIU!=''">
                                            <u>{{getLanguage["GL"]["P"]}}</u>
                                        </a>
                                        <div v-else>-</div>
                                    </div>
                                </template>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Treeselect from '@riophae/vue-treeselect'
    import { customtreeselect } from '@/views/CustomControl/index.js'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import Loading from 'vue-loading-overlay';
    import DateRangePicker from 'vue2-daterange-picker'
    import 'vue-loading-overlay/dist/vue-loading.css';
    import { mapGetters } from 'vuex';
    import moment from "moment";
    import genericHelper from "@/modules/GenericHelper.js";
    import { integer, required, between, requiredIf } from 'vuelidate/lib/validators'
    import { constPromoGroup, constAccessType, constImgURClientId, loadingFullScreen } from '@/modules/Constant.js';
    import Vue from 'vue'
    import VueHotkey from 'v-hotkey'
    import Axios from 'axios';
    import Editor from '@tinymce/tinymce-vue'
    import $ from 'jquery'
    import Sortable from 'sortablejs';
    import draggable from 'vuedraggable';
    //Vue.use(require('vue-shortkey'))
    Vue.use(VueHotkey)

    export default {
        mixins: [genericHelper],
        components: {
            Treeselect,
            customtreeselect,
            Loading,
            'editor': Editor,
            DateRangePicker,
            Sortable,
            draggable
        },
        data() {
            return {
                isSubAgent: false,
                int_RC: 100, //Row Count
                int_Total: 0,
                int_Page: 1,
                int_IC: 1, // Item Count
                int_TP: 1, //Total Page
                str_tableSortBy: "CTS", //(sort the table col name)
                bool_isSort: true, // Table Ascending Descending
                bool_isAMV: false, // Add Modal Visible
                bool_showSearchBar: true,
                bool_fullLoading: false,
                bool_fullScreen: loadingFullScreen, //Full Screen
                bool_fullPreview: false,
                bool_unlockCusUrl: false,// custom URL
                arr_FV: {
                    "PT": "",
                    "PC": null,
                    "L": null,
                    "AGI": null,
                    "ST": null,
                    "PUBL": null,
                    "SAGAGI": null,
                    "CTS": {
                        startDate: "",
                        endDate: ""
                    }
                },
                arr_PromotionCMS: [],
                obj_PromotionCMS: {
                    "I": 0,
                    "RS": 2,
                    "AGI": "",
                    "AGIT": null,
                    "SAGAGI": null,
                    "PI": null,
                    "L": "",
                    "Language": null,
                    "PT": "",
                    "PURL": "",
                    "PSD": "",
                    "PFD": "",
                    "SB": 0,
                    "PIU": "",
                    "PMIU": "",
                    "ARP": false,
                    "OI": "",
                    "OT": null,
                    "OD": null,
                    "OTP": null,
                    "PP": 1,
                    "POL": false,
                    "PCI": null,
                    "ATL": null,
                    "ATP": null,
                    "HS": "",
                    "FS": ""
                },
                editorText: "",
                brand: "",
                dd_agentgroup: [],
                dd_agentgroupfs: [],
                dd_promocode: [],
                dd_promoStatus: [],
                dd_publishingStatus: [],
                dd_language: [],
                dd_languagefs: [],
                dd_po: [],
                bool_promotionCMSCV: false,
                //int_newImgCount: 0,
                //int_uploadedImgCount: 0,
                //bool_NewPIUFileErr: false,
                bool_NewPMIUFileErr: false,
                bool_isDDMV: false,
                bool_showPPI: true,
                bool_showAS: true,
                bool_enableMultiPage: false,

                NewPIUFile: null,
                landscapePreview: null,
                landscapeOrientation: null,
                NewPMIUFile: null,
                portraitPreview: null,
                portraitOrientation: null,
                NewOIIUFile: null,
                ogPreview: null,
                ogOrientation: null,


                constAccessType: constAccessType,
                init: {
                    height: 500,
                    plugins: [
                        'lists advlist',
                        'image imagetools',
                        'link autolink',
                        'table',
                        'charmap',
                        'searchreplace visualblocks code fullscreen',
                        'print preview anchor insertdatetime',
                        'help codesample hr pagebreak nonbreaking toc textpattern noneditable',
                        'importcss',
                        'directionality',
                        'visualchars',
                        'emoticons',
                        'autosave',
                        'paste',
                        'wordcount'
                    ],
                    selector: 'textarea',
                    toolbar:
                        'undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media template link anchor codesample | ltr rtl',
                    branding: false,
                    font_formats:
                        "Andale Mono=andale mono,times; Arial=arial,helvetica,sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua,palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new,courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact,chicago; Khmer OS Content=Khmer OS Content; Symbol=symbol; Tahoma=tahoma,arial,helvetica,sans-serif; Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet MS=trebuchet ms,geneva; Verdana=verdana,geneva; Webdings=webdings; Wingdings=wingdings,zapf dingbats",
                    paste_as_text: true,
                    paste_data_images: true,
                    menubar: true,
                    file_picker_callback: function (cb) {
                        var input = document.createElement('input');
                        input.setAttribute('type', 'file');
                        input.setAttribute('accept', 'image/*');

                        input.onchange = function () {
                            this.bool_fullLoading = true;
                            var file = this.files[0];
                            var reader = new FileReader();

                            if (!file) {
                                return;
                            }
                            if (!file.name.match(/\.(jpg|jpeg|png)$/)) {
                                return;
                            }

                            reader.onload = function () {
                                var that = this;
                                var formData = new FormData();
                                formData.append('image', file)

                                Axios({
                                    url: 'https://api.imgur.com/3/image',
                                    method: 'POST',
                                    headers: {
                                        'Authorization': 'Client-ID ' + constImgURClientId
                                    },
                                    data: formData
                                })
                                    .then((result) => {
                                        let url = result.data.data.link;
                                        that.bool_fullLoading = true;
                                        cb(url, { title: file.name });
                                    })
                                    .catch((err) => {
                                        that.bool_fullLoading = true;
                                        console.log(err);
                                    });
                            };
                            reader.readAsDataURL(file);
                        };
                        input.click();
                    }
                },
                previewUrl: null,
                dd_promocate: [],
                defaultReportHeaders: ['NO', 'ACT', 'RS', 'BN', 'P', 'C', 'O', 'PN', 'L', 'PT', 'PTY', 'CTS', 'LI', 'PI'],
                reportHeaders: [],
                needResetHeaders: false,
            }
        },
        validations: {
            obj_PromotionCMS: {
                "AGIT": { required },
                "PI": {
                    required: requiredIf(function (vm) {
                        return vm.SB == 1;
                    }),
                },
                "PT": { required },
                "Language": { required },
                "PIU": {
                    required: requiredIf(function (vm) {
                        return vm.PT && (vm.PIU || this.NewPIUFile === null);
                    }),
                },
                "PMIU": {
                    required: requiredIf(function (vm) {
                        return vm.PT && (vm.PMIU || this.NewPMIUFile === null);
                    }),
                },
                "PSD": { required },
                "PFD": { required },
                "PP": { integer, between: between(1, 1000), required },
                "PURL": {
                    customValidation(value) {
                        // 自定义验证函数，检查字段是否包含特定字符和空格
                        if (/[&.%*^!$+\s]/.test(value)) {
                        return false;
                        }
                        return true; // 通过验证
                    }
                },
            }
        },
        computed: {
            dynamicPlaceholder() {
                if (this.obj_PromotionCMS.PT) {
                // 执行多次替换操作
                let formattedPT =this.formatPURL(this.obj_PromotionCMS.PT) ;
                     

                return formattedPT;
                } else {
                return this.getLanguage["PM"]["DPT"];
                }
            },
            keymap() {
                return {
                    'enter': {
                        keydown: this.newSearch,
                        keyup: null
                    }
                }
            },
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['checkModuleAccess', 'getUserInfo']),
        },
        watch: {
            bool_isAMV() {
                if (!this.bool_isAMV && this.bool_promotionCMSCV) {
                    this.showSuccessMessage(this.utilGetErrorLanguage("ERR.SS"), this.utilGetErrorLanguage("GL.AS"));
                }
            },
            'obj_PromotionCMS.PT': function (newPT) {
                if(!this.bool_unlockCusUrl){
                    this.obj_PromotionCMS.PURL = this.formatPURL(newPT);
                    if (this.obj_PromotionCMS.I == 0) {
                        this.obj_PromotionCMS.ATL = this.brand + " Promotion " + this.obj_PromotionCMS.PT;
                        this.obj_PromotionCMS.ATP = this.brand + " Promotion " + this.obj_PromotionCMS.PT;
                    }
                }           
            },
            'bool_unlockCusUrl': function (newBool) {
                if(!newBool){
                    this.obj_PromotionCMS.PURL = this.formatPURL(this.obj_PromotionCMS.PT);
                    if (this.obj_PromotionCMS.I == 0) {
                        this.obj_PromotionCMS.ATL = this.brand + " Promotion " + this.obj_PromotionCMS.PT;
                        this.obj_PromotionCMS.ATP = this.brand + " Promotion " + this.obj_PromotionCMS.PT;
                    }
                }
            
            },
            reportHeaders() {
                var that = this;
                if (this.reportHeaders == null) {
                    this.getDataApi(`/api/reports/gc/PromotionDesign`,
                        function (d, s) {
                            if (s) {
                                if (d == null) {
                                    that.reportHeaders = [];
                                    for (var i = 0; i < that.defaultReportHeaders.length; i++) {
                                        if (that.reportHeaders.indexOf(that.defaultReportHeaders[i]) == -1)
                                            that.reportHeaders.push(that.defaultReportHeaders[i]);
                                    }
                                }
                                else {
                                    try {
                                        that.reportHeaders = JSON.parse(d);
                                    } catch (e) {
                                        d += "]";
                                        that.reportHeaders = JSON.parse(d);
                                    }
                                }
                                // hide columns for unauthorized access users
                                if (!(that.checkModuleAccess2(constAccessType.edit) || that.checkModuleAccess2(constAccessType.delete))) {
                                    that.removeDefaultColumn('ACT')
                                    that.removeColumn('ACT')
                                }

                                //// hide columns for other agent type, only show in  agent(which has outlet agent)  & superadmin
                                //if (!(that.getUserInfo.AT == 0 || (that.getUserInfo.AT == 4 && that.getUserInfo.IOL))) {
                                //    that.removeDefaultColumn('O')
                                //    that.removeColumn('O')
                                //}
                            }
                        });
                }
                else {
                    this.getDataApi(`/api/reports/sc/PromotionDesign/` + JSON.stringify(that.reportHeaders),
                        function (d, s) {
                            if (s) {

                            }
                        });
                }

                if (this.reportHeaders != null) {
                    if (that.defaultReportHeaders.length != that.reportHeaders.length)
                        that.needResetHeaders = true;
                    else
                        that.needResetHeaders = false;
                }
            }
        },
        methods: {

            TextValueChange(type, event) {
                if (type == "HS") {
                    this.obj_PromotionCMS.HS = event.target.value;
                }
                else if (type == "FS") {
                    this.obj_PromotionCMS.FS = event.target.value;
                }
            },
            formatPURL(pt) {
                return pt
                    .replace(/ /g, '-')   
                    .replace(/&/g, '-')   
                    .replace(/\./g, '-')  
                    .replace(/%/g, '-')   
                    .replace(/\*/g, '-')  
                    .replace(/\^/g, '-') 
                    .replace(/!/g, '-')   
                    .replace(/\//g, '-')  
                    .replace(/\$/g, '-')  
                    .replace(/\+/g, 'plus') 
                    .toLowerCase()       
                    .replace(/:/g, '-');   
            },
            DateTimeChange(type, event) {
                if (type == "SD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.arr_FV.CTS.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.arr_FV.CTS.startDate = "";
                    }
                }
                if (type == "ED") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.arr_FV.CTS.endDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["ED"]), 1000);
                    } else {
                        this.arr_FV.CTS.endDate = "";
                    }
                }
            },
            renderPromotionGroup(int_promoGroup) {
                var promoGroup = "";
                for (var i = 0; i < constPromoGroup.length; i++) {
                    for (var j = 0; j < constPromoGroup[i].children.length; j++) {
                        if (constPromoGroup[i].children[j].id == int_promoGroup) {
                            promoGroup = constPromoGroup[i].children[j].label;
                            break;
                        }
                    }
                }
                return promoGroup;
            },
            renderAgentGroup(int_agentGroup) {
                var AgentGroup = "";
                var that = this;
                for (var i = 0; i < that.dd_agentgroup.length; i++) {                  
                    if (that.dd_agentgroup[i].children == null)
                    {
                       
                        AgentGroup=this.dd_agentgroup.find(r => r.id == int_agentGroup).label.split("(")[0];
                        return AgentGroup;
                    }

                    for (var j = 0; j < that.dd_agentgroup[i].children.length; j++)
                    {
                        if (that.dd_agentgroup[i].children[j].children != null)
                        {
                            for (var k = 0; k < that.dd_agentgroup[i].children[j].children.length; k++)
                            {
                                if (that.dd_agentgroup[i].children[j].children[k].children != null)
                                {
                                    for (var l = 0; l < that.dd_agentgroup[i].children[j].children[k].children.length; l++)
                                    {
                                        if (that.dd_agentgroup[i].children[j].children[k].children[l].id == int_agentGroup)
                                        {
                                                AgentGroup = that.dd_agentgroup[i].children[j].children[k].children[l].label.split("(")[0];
                                                // that.brand = AgentGroup;
                                                return AgentGroup;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                
                return AgentGroup;
            },
            checkModuleAccess2(type) {
                return this.checkModuleAccess('PD', 'P', type);
            },
            closeAdd() {
                this.bool_isAMV = !this.bool_isAMV;
                this.bool_promotionCMSCV = false;
            },
            closeAdd1() {
                this.previewUrl = null;
                this.bool_fullPreview = !this.bool_fullPreview;
            },
            ctrPage(newPage,inputValue = 1) {
                if (inputValue == 0) {
                    this.int_Page = Math.max(1, Math.min(newPage, this.int_TP));
                }
                else {
                    this.int_Page = (newPage > this.int_TP) ? 1 : (newPage < 1) ? this.int_TP : newPage;
                }
                this.int_IC = this.int_Page;
                this.getPromotionCMSList();
            },
            newSearch() {
                if (!this.bool_isAMV && this.int_Page == this.int_IC) {
                    this.$refs.search.focus();
                    this.int_Page = 1;
                    this.int_IC = 1;
                    this.getPromotionCMSList();
                }
                if (!this.bool_isAMV && this.int_Page != this.int_IC) {
                    this.ctrPage(this.int_Page);
                }
            },
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                }
                else {
                    return value;
                }
            },
            setSortTable(SV) { //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isTAD}
                this.getPromotionCMSList();
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            getDropdownList() {
                var that = this;
                //this.dd_promoStatus = [{
                //    id: "2",
                //    label: "Active"
                //}, {
                //    id: "1",
                //    label: "Inactive/Past"
                //}];
                this.dd_promoStatus = [{
                    id: "2",
                    label: this.getLanguage['GL']['OG']
                }, {
                    id: "1",
                    label: this.getLanguage['TNMT']['TS1']
                },
                {
                    id: "0",
                    label: this.getLanguage["AN"]["E"]
                }];

                this.dd_publishingStatus = [{
                    id: "1",
                    label: this.getLanguage["PM"]["YES"]
                },
                {
                    id: "0",
                    label: this.getLanguage["PM"]["NO"]
                    }];

                this.dd_po = [{ id: '1', label: this.getLanguage['BN']['P'] + " 1" }, { id: '2', label: this.getLanguage['BN']['P'] + " 2" },
                { id: '3', label: this.getLanguage['BN']['P'] + " 3" }, { id: '4', label: this.getLanguage['BN']['P'] + " 4" },
                { id: '5', label: this.getLanguage['BN']['P'] + " 5" }, { id: '6', label: this.getLanguage['BN']['P'] + " 6" },
                { id: '7', label: this.getLanguage['BN']['P'] + " 7" }, { id: '8', label: this.getLanguage['BN']['P'] + " 8" },
                { id: '9', label: this.getLanguage['BN']['P'] + " 9" }, { id: '10', label: this.getLanguage['BN']['P'] + " 10" },
                { id: '11', label: this.getLanguage['BN']['P'] + " 11" }, { id: '12', label: this.getLanguage['BN']['P'] + " 12" },
                { id: '13', label: this.getLanguage['BN']['P'] + " 13" }, { id: '14', label: this.getLanguage['BN']['P'] + " 14" },
                { id: '15', label: this.getLanguage['BN']['P'] + " 15" }, { id: '16', label: this.getLanguage['BN']['P'] + " 16" },
                { id: '17', label: this.getLanguage['BN']['P'] + " 17" }, { id: '18', label: this.getLanguage['BN']['P'] + " 18" },
                { id: '19', label: this.getLanguage['BN']['P'] + " 19" }, { id: '20', label: this.getLanguage['BN']['P'] + " 20" },
                { id: '21', label: this.getLanguage['BN']['P'] + " 21" }, { id: '22', label: this.getLanguage['BN']['P'] + " 22" },
                { id: '23', label: this.getLanguage['BN']['P'] + " 23" }, { id: '24', label: this.getLanguage['BN']['P'] + " 24" },
                    { id: '25', label: this.getLanguage['BN']['P'] + " 25" }];

                this.getDataApi(`/api/dd/lang/0`,
                    function (d, s) {
                        if (s) {
                            //that.dd_language = that.appendSelectAllOption(d.dropdownlist);
                            that.dd_languagefs = that.appendSelectAllOption(d.dropdownlist);
                        }
                    });

                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s) {

                            that.dd_agentgroupfs = that.deepClone(d.dropdownlist);

                            that.dd_agentgroup = that.deepClone(d.dropdownlist);

                            if (that.getUserInfo.ISENS == 1) {
                                that.dd_agentgroup = that.dd_agentgroup.filter(f => f.id == "3-" + that.getUserInfo.AGI);
                            }

                            if (that.dd_agentgroup.length > 0) {
                                that.dd_agentgroup.forEach(that.disableAgentGroupParent);
                            }
                        }
                    });
                this.getDataApi(`/api/dd/promocate`,
                    function (d, s) {
                        if (s) {
                            that.dd_promocate = that.deepClone(d.dropdownlist);
                            that.dd_promocate.forEach(item => {
                                item.label = that.getLanguage['PM'][item.label];
                            });
                        }
                    });
            },
            disableAgentGroupParent(item, index) {
                var agi = item.id.split("-");
                if (agi[0] != "3") {
                    item.isDisabled = true;
                }

                if (item.children && item.children.length > 0) {
                    item.children.forEach(this.disableAgentGroupParent);
                }
            },
            getPromotionCMSList() {
                this.bool_fullLoading = true;

                var that = this;
                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);

                if (this.arr_FV) {
                    if (path) {
                        path += "&";
                    }

                    path += (
                        "f.PT=" + (this.arr_FV["PT"] == null ? "" : this.arr_FV["PT"]) +
                        "&f.PC=" + (this.arr_FV["PC"] == null ? "" : this.arr_FV["PC"]) +
                        "&f.L_csv=" + (this.arr_FV["L"] == null ? "" : this.arr_FV["L"]) +
                        "&f.ST=" + this.arr_FV["ST"] +
                        "&f.PUBL=" + this.arr_FV["PUBL"] +
                        "&f.ATAGI=" + (this.arr_FV["AGI"] == null ? "" : this.arr_FV["AGI"]));

                    if (this.arr_FV.CTS.startDate != "") {
                        var cts_from = this.parseDateToJsonString(this.arr_FV.CTS.startDate);
                        path += "&f.CTS_from=" + cts_from;
                    }
                    if (this.arr_FV.CTS.endDate != "") {
                        var cts_to = this.parseDateToJsonString(this.arr_FV.CTS.endDate);
                        path += "&f.CTS_to=" + cts_to;
                    }

                    if (this.arr_FV["SAGAGI"]) {
                        path += "&f.ATAGI=" + (this.arr_FV["SAGAGI"] == null ? "" : "4-" + this.arr_FV["SAGAGI"])
                    } else {
                        path += "&f.ATAGI=" + (this.arr_FV["AGI"] == null ? "" : this.arr_FV["AGI"]);
                    }
                }

                this.getDataApi(`/api/pcms/l?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.int_TP = Math.max(d.D.TotalPages, 1);
                            that.int_Total = d.D.TotalItems;
                            that.arr_PromotionCMS = d.D.Items;
                            that.isSubAgent = d.D.Items[0].ISA ? d.D.Items[0].ISA : null;
                            that.resizeTableHead();
                        }
                    });
            },
            HTMLEditorTextChange(value) {
                this.editorText = value.level.content;
            },
            AgentGroupChange(value) {
                var agi = 0;
                var that = this;
                if (value != "") {
                    agi = value.split("-")[1];
                }

                var isActive = 2;
                if (this.obj_PromotionCMS.I != 0) {
                    isActive = 0;
                }
                if (agi != 0) {
                    this.getDataApi(`/api/dd/lang/` + agi, function (d, s) {
                        if (s) {
                            that.dd_language = that.appendSelectAllOption(d.dropdownlist);
                        }
                    });

                    this.getDataApi(`/api/dd/promo/${agi}/${isActive}`,
                        function (d, s) {
                            if (s) {
                                that.dd_promocode = d.dropdownlist;

                                if (that.obj_PromotionCMS.PI != null) {
                                    var bool_isExists = false;

                                    for (var i = 0; i < that.dd_promocode.length; i++) {
                                        if (that.dd_promocode[i].id == that.obj_PromotionCMS.PI) {
                                            bool_isExists = true;
                                            break;
                                        }
                                    }

                                    if (!bool_isExists) {
                                        that.obj_PromotionCMS.PI = null;
                                    }
                                }
                            }
                            else {
                                that.dd_promocode = [];
                                that.obj_PromotionCMS.PI = null;
                            }
                        });

                    /* get customize register & agentconfig check it is enable multipage register */
                    this.getDataApi(`/api/rcuz/g/${agi}`,
                        function (d, s) {
                            if (s && d.D != null) {
                                if (d.D.CuzView.length > 0) {
                                    const config = _.some(d.D.CuzView, item => item.CC === "RFWMP");
                                    if (config) {
                                        that.bool_enableMultiPage = true;
                                    } else {
                                        that.bool_enableMultiPage = false;

                                    }
                                }
                            }
                        });
                } else {
                    that.dd_language = [];
                }
               
                if (that.obj_PromotionCMS.PI == null) {
                    that.brand = that.renderAgentGroup(value);
                    if (!that.obj_PromotionCMS.ATL) {
                        that.obj_PromotionCMS.ATL = that.brand + " Promotion " + that.obj_PromotionCMS.PT;
                    }
                    if (!that.obj_PromotionCMS.ATP) {
                        that.obj_PromotionCMS.ATP = that.brand + " Promotion " + that.obj_PromotionCMS.PT;
                    }
                }


                

               
            },
            SubAgentGroupChange(value) {
                var agi = 0;
                var that = this;
                if (value != "") {
                    agi = value;
                }

                var isActive = 2;
                if (this.obj_PromotionCMS.I != 0) {
                    isActive = 0;
                }
                if (agi != 0) {
                    this.getDataApi(`/api/dd/lang/` + agi, function (d, s) {
                        if (s) {
                            that.dd_language = that.appendSelectAllOption(d.dropdownlist);
                        }
                    });
                } else {
                    that.dd_language = [];
                }
                this.getDataApi(`/api/dd/promo/${agi}/${isActive}`,
                    function (d, s) {
                        if (s) {
                            that.dd_promocode = d.dropdownlist;

                            if (that.obj_PromotionCMS.PI != null) {
                                var bool_isExists = false;

                                for (var i = 0; i < that.dd_promocode.length; i++) {
                                    if (that.dd_promocode[i].id == that.obj_PromotionCMS.PI) {
                                        bool_isExists = true;
                                        break;
                                    }
                                }

                                if (!bool_isExists) {
                                    that.obj_PromotionCMS.PI = null;
                                }
                            }
                        }
                        else {
                            that.dd_promocode = [];
                            that.obj_PromotionCMS.PI = null;
                        }
                    });
            },
            PromoCodeChange(value) {
                if (value == undefined) {
                    this.obj_PromotionCMS.PI = null;
                    this.obj_PromotionCMS.SB = 0;
                } else {
                    this.obj_PromotionCMS.SB = 1;
                    this.obj_PromotionCMS.RS = 2;
                }
            },
            ValidationPromotionCMSErrMsg(value, langKey = "") {

                if (this.bool_promotionCMSCV) {
                    if (langKey == "") {
                        langKey = value;
                    }
                    var validateObj = this.$v.obj_PromotionCMS[value];
                    if (value == "PIU" || value == "PMIU") {
                        if (value == "PIU") {
                            if ((validateObj.required != undefined && !validateObj.required) && this.NewPIUFile === null) {
                                return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["PM"][langKey]);
                            }
                        } else if (value == "PMIU") {
                            if ((validateObj.required != undefined && !validateObj.required) && this.NewPMIUFile === null) {
                                return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["PM"][langKey]);
                            }
                        } 
                    } else if (value != "PIU" && value != "PMIU" && value != "OI" && validateObj.required != undefined && !validateObj.required) {
                        return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["PM"][langKey]);
                    } else if (validateObj.between != undefined && !validateObj.between) {
                        return String.format(this.utilGetErrorLanguage('1005'), this.getLanguage["PM"][langKey]);
                    }
                }
            },
            addPromotionCMS() {
                this.bool_promotionCMSCV = false;
                this.bool_fullLoading = true;
                this.bool_unlockCusUrl=false;
                this.obj_PromotionCMS = {
                    "I": 0,
                    "RS": 2,
                    "AGI": "",
                    "AGIT": null,
                    "PI": null,
                    "L": "",
                    "Language": null,
                    "PT": "",
                    "PURL":"",
                    "PSD": "",
                    "PFD": "",
                    "SB": 0,
                    "PIU": "",
                    "PMIU": "",
                    "OI": "",
                    "OT": null,
                    "OD": null,
                    "OTP": null,
                    "PP": 1,
                    "POL": false,
                    "HS": null,
                    "FS": null
                };
                this.editorText = "";
                this.NewPIUFile = null;
                this.NewPMIUFile = null;
                this.NewOIIUFile = null;
                this.landscapePreview = null;
                this.landscapeOrientation = null;
                this.portraitPreview = null;
                this.portraitOrientation = null;
                this.ogPreview = null;
                this.ogOrientation = null;
                this.bool_isAMV = true;
                this.bool_fullLoading = false;
                this.dd_promocode = [];
                //if (this.dd_agentgroup2[0].children == undefined) {
                //    var at = 0;
                //    at = this.dd_agentgroup2[0].id.split("-")[0];
                //    if (at == 3 && that.dd_agentgroup.length < 2) {
                //        this.obj_PromotionCMS.AGIT = this.dd_agentgroup2[0].id;
                //        this.AgentGroupChange(this.obj_PromotionCMS.AGIT);
                //    }
                //}
            },
            editPromotionCMS(id) {
                var that = this;

                this.bool_fullLoading = true;
                this.bool_promotionCMSCV = false;

                this.getDataApi(`/api/pcms/g/${id}`,
                    function (d, s) {
                        that.bool_fullLoading = false;

                        if (s) {
                            that.obj_PromotionCMS = Object.assign(that.obj_PromotionCMS, d.D);

                            var str_PTtoPurl=that.formatPURL(that.obj_PromotionCMS.PT);
                            if(str_PTtoPurl==that.obj_PromotionCMS.PURL){
                                that.bool_unlockCusUrl=false;
                            }else{
                                that.bool_unlockCusUrl=true;
                            }
                         
                            that.editorText = that.obj_PromotionCMS.PFD;

                            if (that.obj_PromotionCMS.SB === true || that.obj_PromotionCMS.SB === 1) {
                                that.obj_PromotionCMS.SB = 1;
                            }
                            else if (that.obj_PromotionCMS.SB === false || that.obj_PromotionCMS.SB === 0) {
                                that.obj_PromotionCMS.SB = 0;
                            }

                            if (that.obj_PromotionCMS.L != null && that.obj_PromotionCMS.L.length > 0) {
                                that.obj_PromotionCMS.Language = that.obj_PromotionCMS.L.split(',');
                            }
                            else {
                                that.obj_PromotionCMS.Language = null;
                            }

                            if (that.obj_PromotionCMS.PI == 0) {
                                that.obj_PromotionCMS.PI = null;
                            }

                            if (that.obj_PromotionCMS.AGI != 0) {
                                that.obj_PromotionCMS.AGIT = "3-" + that.obj_PromotionCMS.AGI;
                                that.AgentGroupChange(that.obj_PromotionCMS.AGIT);
                            } else if (that.obj_PromotionCMS.SAGAGI != 0) {
                                that.obj_PromotionCMS.AGIT = "4-" + that.obj_PromotionCMS.SAGAGI;
                                that.AgentGroupChange(that.obj_PromotionCMS.AGIT);
                            }

                            that.NewPIUFile = null;
                            that.NewPMIUFile = null;
                            that.NewOIIUFile = null;
                            that.landscapePreview = null;
                            that.landscapeOrientation = null;
                            that.portraitPreview = null;
                            that.portraitOrientation = null;
                            that.ogPreview = null;
                            that.ogOrientation = null;
                            if (that.obj_PromotionCMS.PIU) {
                                that.landscapePreview = that.obj_PromotionCMS.PIU;
                                that.checkImageOrientation();
                            }
                            if (that.obj_PromotionCMS.PMIU) {
                                that.portraitPreview = that.obj_PromotionCMS.PMIU;
                                that.checkImageOrientation2();
                            }
                            if (that.obj_PromotionCMS.OI) {
                                that.ogPreview = that.obj_PromotionCMS.OI;
                                that.checkImageOrientation3();
                            }

                            that.bool_isAMV = true;
                        }
                    });
            },
            savePromotionCMS() {
                var that = this;
                if (this.obj_PromotionCMS.AGIT != null && this.obj_PromotionCMS.AGIT.length > 0) {
                    var agi = this.obj_PromotionCMS.AGIT.split("-");
                    this.obj_PromotionCMS.AGI = agi[1];
                }

                if (this.obj_PromotionCMS.Language != null && this.obj_PromotionCMS.Language.length > 0) {
                    this.obj_PromotionCMS.L = this.obj_PromotionCMS.Language.join(',');
                }
                if (this.NewPIUFile != null) {
                    this.obj_PromotionCMS['FPIU'] = this.NewPIUFile;
                }
                else {
                    this.obj_PromotionCMS['FPIU'] = null;
                }

                if (this.NewPMIUFile != null) {
                    this.obj_PromotionCMS['FPMIU'] = this.NewPMIUFile;
                }
                else {
                    this.obj_PromotionCMS['FPMIU'] = null;
                }
                if (this.NewOIIUFile != null) {
                    this.obj_PromotionCMS['FOI'] = this.NewOIIUFile;
                }
                else {
                    this.obj_PromotionCMS['FOI'] = null;
                }

                this.obj_PromotionCMS.PFD = this.editorText;

                this.bool_promotionCMSCV = true;
                this.$v.obj_PromotionCMS.$touch();
                if (!this.$v.obj_PromotionCMS.$error ) {
                    this.bool_fullLoading = true;
                    this.bool_fullScreen = true;

                    if (this.obj_PromotionCMS.SB == "1" || this.obj_PromotionCMS.SB == 1) {
                        this.obj_PromotionCMS.SB = true;
                    }
                    else {
                        this.obj_PromotionCMS.SB = false;
                    }
                    if (this.obj_PromotionCMS.PT) {
                        this.obj_PromotionCMS.PT = this.obj_PromotionCMS.PT.trimLeft();
                        this.obj_PromotionCMS.PT = this.obj_PromotionCMS.PT.trimRight();
                    }
                    //when save, if got subagentid assign it into agentid
                    if (this.obj_PromotionCMS.SAGAGI) {
                        this.obj_PromotionCMS.AGI = this.obj_PromotionCMS.SAGAGI;
                    }

                    this.postDataApiWithAttach(`/api/pcms/s`, this.obj_PromotionCMS,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            that.bool_fullScreen = false;


                            if (s) {

                                that.bool_isAMV = false;
                                that.NewPIUFile = null;
                                that.NewPMIUFile = null;
                                that.NewOIIUFile = null;
                                that.landscapePreview = null;
                                that.landscapeOrientation = null;
                                that.portraitPreview = null;
                                that.portraitOrientation = null;
                                that.ogPreview = null;
                                that.ogOrientation = null;
                                that.getPromotionCMSList();
                            }
                        });

                    //if (this.NewPIUFile != null) {
                    //    this.int_newImgCount++;
                    //    var str_imgname = this.obj_PromotionCMS.PI + "_" + this.obj_PromotionCMS.AGIT + "_W_" + this.NewPIUFile.name;

                    //    this.uploadImgUr(constImgURClientId, this.NewPIUFile, str_imgname,
                    //        function (url, s) {
                    //            var bool_save = false;
                    //            if (s && url != "") {
                    //                that.int_uploadedImgCount++;
                    //                bool_save = true;
                    //                that.obj_PromotionCMS.PIU = url;
                    //            }
                    //            that.savePromotionCMSData(bool_save, "PIU");
                    //        });
                    //}

                    //if (this.NewPMIUFile != null) {
                    //    this.int_newImgCount++;
                    //    var str_imgname = this.obj_PromotionCMS.PI + "_" + this.obj_PromotionCMS.AGIT + "_M_" + this.NewPMIUFile.name;

                    //    this.uploadImgUr(constImgURClientId, this.NewPMIUFile, str_imgname,
                    //        function (url, s) {
                    //            var bool_save = false;
                    //            if (s && url != "") {
                    //                that.int_uploadedImgCount++;
                    //                bool_save = true;
                    //                that.obj_PromotionCMS.PMIU = url;
                    //            }
                    //            that.savePromotionCMSData(bool_save, "PMIU");
                    //        });
                    //}

                    //if (this.int_newImgCount == 0) {
                    //    this.savePromotionCMSData(true, "PMIU");
                    //}

                } else {
                    //get the object for validating.
                    const validation = this.$v["obj_PromotionCMS"];
                    if (!validation) {
                        return;
                    }

                    const input = this.findRequiredInput(validation, this.$refs);
                    if (!input || typeof input.focus !== "function") {
                        return;
                    }

                    input.focus();
                }
            },
            //savePromotionCMSData(bool_isSave, imgFieldName) {
            //    if (bool_isSave && this.int_newImgCount == this.int_uploadedImgCount) {
            //        var that = this;

            //        if (this.obj_PromotionCMS.SB == "1" || this.obj_PromotionCMS.SB == 1) {
            //            this.obj_PromotionCMS.SB = true;
            //        }
            //        else {
            //            this.obj_PromotionCMS.SB = false;
            //        }

            //        this.postDataApi(`/api/pcms/s`, this.obj_PromotionCMS,
            //            function (d, s) {
            //                that.bool_fullLoading = false;
            //                if (s) {
            //                    that.bool_isAMV = false;
            //                    that.getPromotionCMSList();
            //                }
            //            });
            //    }
            //    else if (!bool_isSave) {
            //        if (imgFieldName == "PIU") {
            //            this.bool_NewPIUFileErr = true;
            //        }
            //        else if (imgFieldName == "PIU") {
            //            this.bool_NewPMIUFileErr = true;
            //        }
            //    }
            //},
            removePromotionCMS(d) {
                this.$fire({
                    title: this.getLanguage["GL"]["DLTM"],
                    width: '30em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {
                        this.bool_fullLoading = true;
                        var that = this;
                        var dt = {
                            i: d.I,
                            uts: d.UTS,
                            agi: d.AGI
                        };

                        this.postDataApi(`/api/pcms/d`, dt,
                            function (d, s) {
                                that.bool_fullLoading = false;

                                if (s) {
                                    that.getPromotionCMSList();
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                }
                            });
                    }
                });
            },
            onPIUFileSelected(event) {
                this.obj_PromotionCMS['PIU'] = "";
                this.NewPIUFile = this.validateFile(event);

                const file = event.target.files[0];
                if (file) {
                    const reader = new FileReader();
                    reader.onload = (e) => {
                        this.landscapePreview = e.target.result;
                        this.checkImageOrientation();
                    };
                    reader.readAsDataURL(file);
                } else {
                    this.landscapePreview = null;
                }
            },
            onPMIUFileSelected(event) {
                this.obj_PromotionCMS['PMIU'] = "";
                this.NewPMIUFile = this.validateFile(event);

                const file = event.target.files[0];
                if (file) {
                    const reader = new FileReader();
                    reader.onload = (e) => {
                        this.portraitPreview = e.target.result;
                        this.checkImageOrientation2();
                    };
                    reader.readAsDataURL(file);
                } else {
                    this.portraitPreview = null;
                }
            },
            onOIIUFileSelected(event) {
                this.obj_PromotionCMS['OI'] = "";
                this.NewOIIUFile = this.validateFile(event);

                const file = event.target.files[0];
                if (file) {
                    const reader = new FileReader();
                    reader.onload = (e) => {
                        this.ogPreview = e.target.result;
                        this.checkImageOrientation3();
                    };
                    reader.readAsDataURL(file);
                } else {
                    this.ogPreview = null;
                }
            },
            checkImageOrientation() {
                const img = new Image();
                img.onload = () => {
                    if (img.width > img.height) { //landscape
                        this.landscapeOrientation = 'previewImg landscape';
                    } else if (img.width < img.height) { //portrait
                        this.landscapeOrientation = 'previewImg portrait';
                    } else if (img.width == img.height) { //square
                        this.landscapeOrientation = 'previewImg square';
                    }
                };
                img.src = this.landscapePreview;
            },
            checkImageOrientation2() {
                const img = new Image();
                img.onload = () => {
                    if (img.width > img.height) { //landscape
                        this.portraitOrientation = 'previewImg landscape';
                    } else if (img.width < img.height) { //portrait
                        this.portraitOrientation = 'previewImg portrait';
                    } else if (img.width == img.height) { //square
                        this.portraitOrientation = 'previewImg square';
                    }
                };
                img.src = this.portraitPreview;
            },
            checkImageOrientation3() {
                const img = new Image();
                img.onload = () => {
                    if (img.width > img.height) { //landscape
                        this.ogOrientation = 'previewImg landscape';
                    } else if (img.width < img.height) { //portrait
                        this.ogOrientation = 'previewImg portrait';
                    } else if (img.width == img.height) { //square
                        this.ogOrientation = 'previewImg square';
                    }
                };
                img.src = this.ogPreview;
            },
            clearDateRangeFilter() {
                this.arr_FV.CTS = {
                    startDate: "",
                    endDate: ""
                };
            },
            checkStatus(RS, promoFromDate) {
                var a = this.$parent.checkStatus(RS);
                if (a) {
                    return this.getLanguage['GL']['OG']

                    ////if publish status on, but promotion date haven arrived will display coming soon
                    //const promoDate = new Date(promoFromDate);
                    //const todayDate = new Date();
                    //// Check if promoDate is in the future
                    //if (promoDate.getTime() > todayDate.getTime()) {
                    //    return this.getLanguage['TNMT']['TS1']; // "Coming Soon"
                    //} else {
                    //    return this.getLanguage['GL']['OG']; // "Available"
                    //}
                } else {
                    return this.getLanguage['TNMT']['TS1'];
                }
            },
            checkStatusColor(RS, promoFromDate) {
                var a = this.$parent.checkStatus(RS);
                if (a) {
                    return 'color:green';

                    ////if publish status on, but promotion date haven arrived will display coming soon
                    //const promoDate = new Date(promoFromDate);
                    //const todayDate = new Date();

                    //// Check if promoDate is in the future
                    //if (promoDate.getTime() > todayDate.getTime()) {
                    //    return 'color:orange'; // "Coming Soon"
                    //} else {
                    //    return 'color:green'; // "Available"
                    //}
                } else {
                    return 'color:orange';
                }
            },
            setPreview(value) {
                this.previewUrl = value;
                this.bool_fullPreview = true;
            },
            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");

                header.addEventListener("scroll", () => {
                    body.scrollLeft = header.scrollLeft;
                });

                body.addEventListener("scroll", () => {
                    header.scrollLeft = body.scrollLeft;
                });
            },
            calculateWidths() {
                $('#tHead, #tBody').scrollLeft(0);
                const tables = this.$el.querySelectorAll('#tBody .custom-table');
                const headerCells = this.$el.querySelectorAll('#tHead .custom-table thead tr:nth-child(1) th');

                if (!headerCells.length) return;

                tables.forEach((table) => {
                    const bodyCells = table.querySelectorAll('tbody tr:first-child td');
                    if (!bodyCells.length) return;

                    // Reset all widths
                    [...headerCells, ...table.querySelectorAll('tbody tr td')].forEach(cell => cell.style.width = '');

                    // Apply new widths
                    bodyCells.forEach((cell, index) => {
                        const width = `${cell.getBoundingClientRect().width}px`;
                        if (headerCells[index]) headerCells[index].style.width = width;
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach(td => td.style.width = width);
                    });
                });
            },
            initTableObserver() {
                const bodyTable = this.$el.querySelector('#tBody');

                // Observe changes in the body table
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                observer.observe(bodyTable, { childList: true, subtree: true });
                this.calculateWidths();
            },
            renderClassName(header, data) {
                if (header == 'PI') {
                    return "tableCtnRight";
                } else if (header == 'P' || header == 'C' || header == 'P' || header == 'O') {
                    return "text-center";
                }
            },
            resetColumn(headerName) {
                var that = this;
                for (var i = 0; i < that.defaultReportHeaders.length; i++) {
                    that.$set(that.reportHeaders, i, that.defaultReportHeaders[i])
                }
                this.resizeTableHead();
            },
            removeColumn(headerName) {
                var that = this;
                const index = that.reportHeaders.indexOf(headerName);
                if (index > -1)
                    that.reportHeaders.splice(index, 1);
                this.resizeTableHead();
            },
            removeDefaultColumn(headerName) {
                var that = this;
                const index = that.defaultReportHeaders.indexOf(headerName);
                if (index > -1)
                    that.defaultReportHeaders.splice(index, 1);
                this.resizeTableHead();
            },

            showSectionBasedRole(type) {
                var that = this;
                if (type == 'ppi') {
                    this.bool_showPPI = (this.bool_showPPI ? this.bool_showPPI = false : this.bool_showPPI = true);
                }
                if (type == 'as') {
                    this.bool_showAS = (this.bool_showAS ? this.bool_showAS = false : this.bool_showAS = true);
                }
            },
            setCollapseExpandIcon(settingType) {
                if (settingType == 'PPI') {
                    if (this.bool_showPI) {
                        return "chevron-container chevron-up";
                    } else if (!this.bool_showPI) {
                        return "chevron-container";
                    }
                } else if (settingType == 'AS') {
                    if (this.bool_showPS) {
                        return "chevron-container chevron-up";
                    } else if (!this.bool_showPS) {
                        return "chevron-container";
                    }
                }
            },
            savePublishStatus(data) {
                this.bool_fullLoading = true;
                var that = this;

                data.RS = data.RS == 2 ? 1 : 2;
                this.postDataApi(`/api/pcms/upcmss`, data,
                    function (d, s) {
                        that.bool_fullLoading = false;

                        if (s) {
                            that.getPromotionCMSList();
                            that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.PAS"));
                        }
                    });
            },
            saveOutletAgentStatus(data) {
                this.bool_fullLoading = true;
                var that = this;

                data.POL = data.POL ? 0 : 1;
                this.postDataApi(`/api/pcms/upcmspol`, data,
                    function (d, s) {
                        that.bool_fullLoading = false;

                        if (s) {
                            that.getPromotionCMSList();
                            that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.OAAS"));
                        }
                    });
            },
            saveClaimStatus(data) {
                this.bool_fullLoading = true;
                var that = this;

                data.SB = data.SB  ? 0 : 1;
                this.postDataApi(`/api/pcms/upcmssb`, data,
                    function (d, s) {
                        that.bool_fullLoading = false;

                        if (s) {
                            that.getPromotionCMSList();
                            that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.CAS"));
                        }
                    });
            },
            positionChange(value) {
                var p = this.renderPosition(value);
            },
            renderPosition(value) {
                var Position = "";
                var that = this;
                for (var i = 0; i < that.dd_po.length; i++) {
                    if (that.dd_po[i].id == value) {
                        Position = that.dd_po[i].label;
                        return Position;
                    }
                }
                return Position;
            },
            disabledPointer() {
                return (!this.checkModuleAccess2(constAccessType.edit)) ? "cursor:not-allowed; filter:none" : "";
            },
        },
        created() {
            this.reportHeaders = null;
            this.$parent.showSubMenu = 'P';
            this.$parent.showActiveMenu = 'P.PD';
            this.$parent.showSubSubMenu = '';
            this.arr_FV.PC = this.$route.query.pc;
            this.arr_FV.PT = this.$route.query.pt;
            this.getDropdownList();
            this.getPromotionCMSList();
            this.isSENS = this.getUserInfo.ISENS;
            this.curAGI = this.getUserInfo.AGI;
        }
    }
</script>
<style scoped>
    .inline-checkbox{
        display: inline-block !important;
        vertical-align: baseline;
    }
    .tab-content .tab-pane {
        padding: 5px 0px;
    }

   /* .vue-treeselect__multi-value-label div, .vue-treeselect__label {
        border-spacing: 0;
    }

    .vue-treeselect__multi-value-item {
        font-size: 12px;
    }

    .vue-treeselect__control {
        padding-left: 2px;
        padding-right: 2px;
    }

    .vue-treeselect__value-remove, .vue-treeselect__multi-value-label {
        padding: 0 3px;
    }

    .vue-treeselect__x-container {
        width: 7px;
    }*/

    .flagClass {
        height: 20px;
        width: 20px;
    }

    #PromoS .row.mx-3 {
     padding: 10px 0px;
     border-top: solid 1px rgba(0,0,21,.2);
     border-bottom: solid 1px rgba(0,0,21,.2);
 }

     #PromoS .row.mx-3:hover {
         background: rgb(207 207 207 / 80%);
         border-top: solid 1px #909090;
         border-bottom: solid 1px #909090;
     }

 #PromoS .col-7 label {
     width: 100%;
     padding-top: 0px;
 }

     #PromoS .col-7 label::after {
         content: ":";
         float: right;
     }

 #PromoS .promotion-game-list input[type="checkbox"] {
     margin: 0;
 }

 #PromoS .ErrMsg {
     font-weight: 600;
     font-family: "IBM Plex Sans", "Inconsolata Monospace", Calibri, "Open Sans", sans-serif;
 }

    .PopUpActions {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

        .PopUpActions * {
            color: #000;
            font-size: 12px;
            letter-spacing: .02em;
            font-weight: bold;
        }

        .PopUpActions button, .PopUpActions a {
            border: 0;
            background: 0 0;
            cursor: pointer;
            outline: 0
        }

    .PopUpActions-picsart {
        display: none;
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        z-index: 1207
    }

        .PopUpActions-picsart iframe {
            border: 0
        }

    .PopUpActions-fileInput {
        opacity: 0;
        position: absolute;
        z-index: -1
    }

    .PopUpActions-filePicker, .PopUpActions-textPicker input, .PopUpActions-extra button, .PopUpActions-extra a {
        transition: opacity .3s,border .5s
    }

        .PopUpActions-filePicker:hover, .PopUpActions-textPicker input:hover, .PopUpActions-extra button:hover, .PopUpActions-extra a:hover {
            opacity: .75
        }

    .PopUpActions-filePicker {
        height: 25px;
        cursor: pointer
    }

        .PopUpActions-filePicker img {
            margin-right: 10px
        }

    .PopUpActions-divider {
        height: 10px;
        margin-top: 5px;
        margin-bottom: 10px;
        display: flex;
        align-items: center;
    }

    .PopUpActions-divider--line {
        width: 40px;
        height: 1px;
        margin: 0 16px;
        background-color: #000;
        opacity: .12
    }

    .PopUpActions-textPicker {
        height: 25px;
        max-width: 320px;
        /* margin-bottom:48px; */
    }

        .PopUpActions-textPicker input {
            display: block;
            width: 100%;
            height: 100%;
            border-radius: 3px;
            text-align: center;
            background-color: #272a33;
            border: unset;
            outline: unset;
            border: 1px solid transparent;
            color: #fff;
        }

            .PopUpActions-textPicker input::placeholder {
                color: #fff
            }

            .PopUpActions-textPicker input::-ms-input-placeholder {
                color: #fff
            }

            .PopUpActions-textPicker input:hover {
                border: 1px solid;
                opacity: .75;
                border: 1px solid rgba(200,191,255,.5)
            }

            .PopUpActions-textPicker input:focus {
                opacity: 1;
                border: 1px solid #c8bfff
            }

                .PopUpActions-textPicker input:focus::placeholder {
                    opacity: 0
                }

                .PopUpActions-textPicker input:focus::-webkit-input-placeholder {
                    opacity: 0
                }

                .PopUpActions-textPicker input:focus:-moz-placeholder {
                    opacity: 0
                }

                .PopUpActions-textPicker input:focus::-moz-placeholder {
                    opacity: 0
                }

                .PopUpActions-textPicker input:focus:-ms-input-placeholder {
                    opacity: 0
                }

    #PromoS .custom-table th {
        position: relative;
        z-index: auto;
    }

    .previewImg.landscape {
        width: 300px;
        height: auto;
    }

    .previewImg.portrait {
        width: auto;
        height: 300px;
    }

    .previewImg.square {
        width: 150px;
        height: 150px;
    }
</style>



// WEBPACK FOOTER //
// src/components/SideMenu/Promotion/PromotionDesign.vue